export default __webpack_public_path__ + "static/media/Logo_German.848c3aa2.png";